let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("5n5xc")).then(() => parcelRequire('4KnVF'));